import { render, staticRenderFns } from "./WsTest.vue?vue&type=template&id=6ae364f7&scoped=true&"
import script from "./WsTest.vue?vue&type=script&lang=js&"
export * from "./WsTest.vue?vue&type=script&lang=js&"
import style0 from "./WsTest.vue?vue&type=style&index=0&id=6ae364f7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae364f7",
  null
  
)

export default component.exports